/*
* @Author: yinxiaolong
* @Date:   2017-09-17 22:07:58
* @Last Modified by:   yinxiaolong
* @Last Modified time: 2017-09-17 22:16:49
*/
export const  APP_TYPE =  '3' ;//应用类型：1=ios，2=android，3=web
export const  SALT = 'GCC-API' ;//盐
export const  VERSION = '1.0' ;//版本号
export const  DEVICE_CODE = 'Browser' ;//设备码 
export const  SECRET = 'Rp08940RuGeCbgRRXH1mytqTkvCFkFzXD3tKkB'; //密钥
//export const  API_HOST = 'https://erp-api.chenyaowen.greencheng.com';
export const  API_HOST = process.env.API_HOST;
//export const  API_HOST = 'http://api.basic.net';



// WEBPACK FOOTER //
// ./src/utils/config.js